import PropTypes from 'prop-types';
import React from 'react';
import { Col, Row, Card, CardBody } from 'reactstrap';

import { Input } from '@/components/form';
import ResourceForm from '@/components/resources/form';
import View from '@/components/view';

const TypeClientForm = ({ match }) => {
  return (
    <View>
      <ResourceForm resource="TypeClient" id={match.params.id} initialValues={{ name: '', color: '#0d9fdb' }}>
        {({ submitting, renderActions }) => (
          <>
            <Card>
              <CardBody className={submitting ? 'loading' : ''}>
                <Row>
                  <Col lg="6">
                    <Row>
                      <Col lg={12}>
                        <Input name="name" />
                      </Col>
                    </Row>
                  </Col>
                  <Col lg="6">
                    <Row>
                      <Col lg={12}>
                        <Input type="color" name="color" />
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </CardBody>
            </Card>
            <div className="mt-4 mb-4">{renderActions()}</div>
          </>
        )}
      </ResourceForm>
    </View>
  );
};

TypeClientForm.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({ id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]) })
  }).isRequired
};

export default TypeClientForm;
